import styled from 'styled-components';

export const StyledDashboardGridRow = styled.div`
   display: flex;
   height: 292px;
   gap: 12px;
`;
StyledDashboardGridRow.displayName = 'StyledDashboardGridRow';

export const StyledDashboardGridBottomRow = styled.div`
   display: flex;
   height: 412px;
   gap: 12px;
`;
StyledDashboardGridBottomRow.displayName = 'StyledDashboardGridBottomRow';
